import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import { ErrorProvider } from './Error/ErrorBoundary';
import AppWithInterceptor from './AppWithInterceptor';

createRoot(document.getElementById('root')!).render(
  <ErrorProvider>
    <AppWithInterceptor />
  </ErrorProvider>
);
